<button *ngFor="let action of allowedActions" (click)="onApplyAction(action)" class="btn btn-flat-primary-alt ms-2">{{ label(action) | translate }}</button>